import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { DIMENSION_GROUPS, useGetDimensionGroup } from "../../../../hooks/useGetDimensionGroup";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var Icon = function Icon(_ref) {
  var step = _ref.step,
    icon = _ref.icon,
    isMobileView = _ref.isMobileView;
  var dimension = useGetDimensionGroup();
  var isMobile = dimension === DIMENSION_GROUPS.mobile;
  var isMobileViewType = isMobileView && isMobile;
  return step || icon ? /*#__PURE__*/React.createElement("div", {
    className: cn({
      'icon-wrapper': icon && !step,
      'step-wrapper': step,
      'mobile-icon': isMobileViewType
    }),
    "data-t-id": "components-Icon"
  }, !!step && /*#__PURE__*/React.createElement(Text, {
    size: "size5-m"
  }, step), icon && !step && /*#__PURE__*/React.createElement("img", {
    alt: "icon",
    className: cn('icon'),
    src: icon
  })) : null;
};